export default "__VITE_PUBLIC_ASSET__e858dbfd__"